import { AnalyticsEvents } from './events';

/**
 * Determines the sign-up category based on the current URL pathname.
 * This helps attribute user registration to the correct screen.
 *
 * @param pathname - The current window.location.pathname.
 * @returns The category string for the current screen.
 */
export function getCategoryFromPathname(pathname: string): string {
  if (pathname.includes('/app/campaigns/')) {
    return AnalyticsEvents.SIGN_UP.values.CATEGORY.CAMPAIGN_SCREEN;
  }
  if (pathname.includes('/app/campaigns')) {
    return AnalyticsEvents.SIGN_UP.values.CATEGORY.CAMPAIGNS_LIST_SCREEN;
  }
  if (pathname.includes('/app/profile')) {
    return AnalyticsEvents.SIGN_UP.values.CATEGORY.PROFILE_SCREEN;
  }
  if (pathname.includes('/app/register')) {
    return AnalyticsEvents.SIGN_UP.values.CATEGORY.REGISTER_SCREEN;
  }
  return AnalyticsEvents.SIGN_UP.values.CATEGORY.FALLBACK;
}
